if (!customElements.get('free-shipping-bar')) {
  customElements.define('free-shipping-bar', class FreeShippingBar extends HTMLElement {
    constructor() {
      super();
      this.unreachedMessage = this.querySelector('.free-shipping-bar__unreached-message');
      this.reachedMessage = this.querySelector('.free-shipping-bar__reached-message');
      this.exceededMessage = this.querySelector('.free-shipping-bar__exceeded-message');
      if(this.unreachedMessage) {
        this.unreachedMessageText = this.unreachedMessage.innerHTML;
      }
      this.percentNumber = this.querySelector('.free-shipping-bar__progress-number');
      if(!this.dataset.threshold) return;
      this.threshold = parseInt(this.dataset.threshold);
      this.maxThreshold = this.dataset.maxThreshold ? parseInt(this.dataset.maxThreshold) : null;
      this.calculateBar(parseInt(this.dataset.total));
      this.onCartChangeHandler = this.onCartChange.bind(this);
      document.addEventListener('afterCartChanged', this.onCartChangeHandler);
      document.addEventListener('afterUpdateQuantity', this.onCartChangeHandler);
    }

    disconnectedCallback() {
      document.removeEventListener('afterCartChanged', this.onCartChangeHandler);
      document.removeEventListener('afterUpdateQuantity', this.onCartChangeHandler);
    }

    calculateBar(currentTotal) {
      const total = currentTotal / parseFloat(Shopify.currency.rate);
      if (this.maxThreshold && total > this.maxThreshold) {
        this.style.setProperty('--percent', '100%');
        this.classList.remove('completed');
        this.classList.add('exceeded');
        this.hideUnreachedMessage();
        this.hideReachedMessage();
        this.showExceededMessage();
        this.percentNumber.textContent = '';
      } else if(total >= this.threshold) {
        this.style.setProperty('--percent', '100%');
        this.classList.remove('exceeded');
        this.classList.add('completed');
        this.hideUnreachedMessage();
        this.hideExceededMessage();
        this.showReachedMessage();
        this.percentNumber.textContent = `100%`;
      } else {
        const remain = this.threshold - total;
        const percent = (total * 100) / this.threshold;
        this.style.setProperty('--percent', `${percent}%`);
        this.classList.remove('completed');
        this.classList.remove('exceeded');
        this.hideReachedMessage();
        this.hideExceededMessage();
        this.showUnreachedMessage(remain);
        this.percentNumber.textContent = `${Math.floor(percent)}%`;
      }
    }

    onCartChange(event) {
      const cartData = event && event.detail && event.detail.cartData;
      if (cartData && typeof cartData.total_price === 'number' && Array.isArray(cartData.items)) {
        // Full cart response (e.g. /cart/change.js from quantity update)
        this.updateFromCartData(cartData);
      } else {
        this.fetchAndUpdateBar();
      }
    }

    fetchAndUpdateBar() {
      fetch(`${routes.cart_url}.js`)
        .then((response) => response.json())
        .then((response) => this.updateFromCartData(response));
    }

    updateFromCartData(cartData) {
      let totalPrice = cartData.total_price;
      if (freeShippingBarExcludeProducts.length > 0 && cartData.items && cartData.items.length > 0) {
        cartData.items.forEach((item) => {
          if(freeShippingBarExcludeProducts.includes(item.product_id)) {
            totalPrice -= item.final_line_price;
          }
        });
      }
      this.calculateBar(totalPrice);
    }

    showUnreachedMessage(remainAmount) {
      if(!this.unreachedMessageText && this.unreachedMessage) return;
      const remainPrice = Shopify.showPrice(remainAmount);
      this.unreachedMessage.classList.remove('hidden');
      this.unreachedMessage.innerHTML = this.unreachedMessageText.replace('[remain]', `${remainPrice}`);
    }

    hideUnreachedMessage() {
      if(!this.unreachedMessage) return;
      this.unreachedMessage.classList.add('hidden');
    }

    showReachedMessage(remainAmount) {
      if(!this.reachedMessage) return;
      this.reachedMessage.classList.remove('hidden')
    }

    hideReachedMessage() {
      if(!this.reachedMessage) return;
      this.reachedMessage.classList.add('hidden');
    }

    showExceededMessage() {
      if(!this.exceededMessage) return;
      this.exceededMessage.classList.remove('hidden');
    }

    hideExceededMessage() {
      if(!this.exceededMessage) return;
      this.exceededMessage.classList.add('hidden');
    }
  });
}